/**
 * Gets the target element from an event, handling text nodes.
 * @param event The event to get the target from.
 * @returns The target HTMLElement or null.
 */
function getTarget(event: Event): HTMLElement | null {
	let customEventTarget = (event.target ?? event.srcElement ?? document) as HTMLElement;

	while (customEventTarget != null && customEventTarget.nodeType === Node.TEXT_NODE) {
		customEventTarget = customEventTarget.parentNode as HTMLElement;
	}

	return customEventTarget;
}

/**
 * Finds the first ancestor element (or the target itself) that matches the specified CSS selector.
 * Traverses up from the event target to the event's current target.
 * @param event The event to check.
 * @param selector The CSS selector to match against.
 * @returns The matching HTMLElement or undefined if no match is found.
 */
export default function eventMatches(event: Event, selector: string): HTMLElement | undefined {
	const root = event.currentTarget as HTMLElement;
	const body = document.body;
	let target = getTarget(event);

	while (target != null && target != root) {
		if (target.matches(selector) && (root == body || root.contains(target))) {
			return target;
		}

		target = target.parentElement;
	}

	return undefined;
}
